import { render, staticRenderFns } from "./OfflineMirrorDialog.vue?vue&type=template&id=2a7a4a20&scoped=true"
import script from "./OfflineMirrorDialog.vue?vue&type=script&lang=ts"
export * from "./OfflineMirrorDialog.vue?vue&type=script&lang=ts"
import style0 from "./OfflineMirrorDialog.vue?vue&type=style&index=0&id=2a7a4a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a4a20",
  null
  
)

export default component.exports